import React from "react";

/** Small gray label with a company's name. */
export function CompanyPill({ name, className = "" }: { name: string; className?: string }) {
  return (
    <span className={`inline-block rounded-full bg-gray-100 px-2 py-0.5 text-xs font-normal text-gray-600 ${className}`}>
      {name}
    </span>
  );
}

interface UserNameWithCompanyProps {
  name: string;
  companyName?: string | null;
  /** Company the person writes from. */
  companyId?: string | null;
  /** Company the surrounding content belongs to; a person from it needs no label. */
  ownCompanyId: string;
}

/** A person's name, followed by a small gray label of their company when it differs from `ownCompanyId`. */
export function UserNameWithCompany({ name, companyName, companyId, ownCompanyId }: UserNameWithCompanyProps) {
  return (
    <>
      {name}
      {companyName && companyId !== ownCompanyId ? <CompanyPill name={companyName} className="ml-2 align-middle" /> : null}
    </>
  );
}
